import React from 'react';
export var AddIcon = function () { return (React.createElement("svg", { viewBox: "0 0 16 16" },
    React.createElement("path", { fill: "#54b948", d: "M16 6.5H9.5V0h-3v6.5H0v3h6.5V16h3V9.5H16z" }))); };
//# sourceMappingURL=AddIcon.js.map